<script setup lang="ts">
import { getSeoObject } from '~/helpers/seo';
import { useRoute } from 'vue-router';

const { data } = useCustomFetch('/api/strapi/common-datum');
const { data: seoData } = useCustomFetch('/api/strapi/default-seo');

useSeoMeta(getSeoObject(seoData.value?.seo));

provide('commonData', data);
const route = useRoute();
</script>

<template>
  <NuxtLayout>
    <main class="main">
      <NuxtPage />
    </main>
  </NuxtLayout>
</template>

<style lang="scss">
@use '@/assets/scss/main' as *;
</style>
